<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card>
                        <v-toolbar dense >
                          <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="getItems(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        <v-spacer/>
                         <v-btn small text color="success"  @click="state='new', form=true"><v-icon left >mdi-plus-box</v-icon> New Delivery</v-btn>
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-3"
                                :headers="headers"
                                :search="search"
                                :items="deliveries"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td style="width: 150px;">
                                               <v-icon  left small color="error" @click="dr=item, confirm=true" v-if="item.status == 'on-process'" >mdi-delete</v-icon>
                                                <v-icon small left color="success" v-if="item.status != 'booking'"  @click="$router.push('delivery-view/' + item.id).catch(err => {})">mdi-open-in-new</v-icon>
                                            {{ item.number }}
                                            <v-chip color='info' v-if="item.status == 'booking'" small>
                                              <v-icon small left @click="$router.push('delivery-view/' + item.id).catch(err => {})">mdi-open-in-new</v-icon>
                                              Booking Request 
                                            </v-chip>
                                            
                                            </td>
                                             <td >
                                                {{ item.salesman_name}}
                                            </td>
                                             <td>
                                                {{ item.created | moment($date_format) }}
                                            </td>
                                             <td>
                                               <template v-if="item.status != 'on-process' && item.status != 'booking' && item.status != 'approved'">
                                                {{ item.outbound_date | moment($date_format) }}
                                              </template>
                                            </td>
                                            <td>
                                               <template v-if="item.status == 'inbound' || item.status == 'verified'">
                                                {{ item.inbound_date | moment($date_format) }}
                                              </template>
                                            </td>
                                             <td :class="STATUS_TEXT(item.status)">
                                               {{ item.status }}
                                            </td>
                                            <td :class="STATUS_TEXT(item.status)" class="text-right">
                                               {{ $money(item.load) }}
                                            </td>
                                            
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-dr-form :show="form"  @DialogEvent="formEvent" />
      <va-confirm :show="confirm" cancelbtn="No" okbtn="Delete" text="Would you like to delete this item?" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      confirm: false,
        form: false,
        state: 'new',
        menu: false,
         from_date:'',
        to_date: '',
        dr:{},
        fishcar: {},
        search:'',
        deliveries:[],
        headers: [
              { text: 'D.R. #', value: 'number'},
              { text: 'SALESMAN', value: 'salesman_name'},
              { text: 'CREATED', value: 'created'},
              { text: 'OUTBOUND', value: 'outbound_date'},
              { text: 'INBOUND', value: 'inbound_date'},
              { text: 'STATUS', value: 'status'},
              { text: 'LOAD AMOUNT',  align: 'right', value: 'load'},
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.GET_USERS()
          this.GET_TRUCKS()
          this.GET_DRIVERS()
          var current_date = this.$moment()
          var startdate = current_date.subtract(7, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(){
          this.form = false
          this.getItems()
      },
      cEvent(data) {
        this.confirm = false
        if(data != 'cancel') {
            this.removeDr()
        }
      },
      removeDr(){
        this.$http.post("delivery/delete", this.dr).then(response => {
            this.GET_RESPONSE(response)
            this.getItems()
          }).catch(e => {
           console.log(e.data)
         })
      },
      getItems: function() {
        this.$http.post("delivery/list",  {from_date:this.from_date, to_date: this.to_date}).then(response => {
              response.data.items != null?this.deliveries = response.data.items:this.deliveries=[]
          }).catch(e => {
           console.log(e.data)
         })
     }
     
    }
  }
</script>